<template>
  <div>
    <div :class="['wrap-tree px-4',wrapTreeClass, 'box-content']">
      <div class="peizhi-title text-theme-black-850 flex items-center mt-2 justify-between" v-if="showDimensionHead">
        <div class="flex items-center"><span @click="clickDimensionTiltle">{{settingName[treetype]}}配置</span><i style="margin-left:2px;" class="text-sm iconfont icon-shuoming text-theme-black-350 cursor-pointer" @click.stop="openTipDialog"></i></div>
        <slot name="one-level-icon"><i v-if="treeData.length > 0" class="el-icon-plus hover-blue-icon cursor-pointer" @click.stop="clickOneLevelIcon"></i></slot>
      </div>
      <!-- 暂无数据情况 -->
      <div v-if="treeData.length < 1" class="no-data-tree">
        <div class="text-center add-word flex items-center justify-center cursor-pointer" @click.stop="clickOneLevelIcon">
          <img class="mr-1" src="@/assets/img/index-stat/add.png" alt="">
          <span>{{treetype == 2 ? '(按需)':''}}添加{{settingName[treetype]}}</span></div> <!--{{treetype == 2 ? '(按需)':''}} -->
      </div>
      <template v-else>
        <el-tree
          ref="tree"
          :data="treeDataArr"
          node-key="id"
          icon-class="hidden"
          :default-expanded-keys="showExpanedKeys"
          :current-node-key="showCurNode"
          :filter-node-method="filterTreeNode"
          :highlight-current="true"
          :props="defaultProps"
          @node-expand="openNode"
          @node-collapse="closeNode"
          >
          <span class="custom-tree-node flex items-center flex-1 pl-1 inline-block text-theme-black-850"
            slot-scope="{ node, data }"
            @click="clickTreeNode(node,data)"
          >
            <i v-if="!isShowLast && !data.children?.find(item => (item.children && item.children.length > 0) || item.fatherId == 0)"></i>
            <template v-else-if="data.children && data.children.length > 0">
              <i v-if="node.expanded" class="el-icon-caret-right custom-icon-tree rotate90 mr-1"></i>
              <i v-else class="el-icon-caret-right custom-icon-tree mr-1"></i>
            </template>
            <span class="inline-block flex items-center flex-1">
              <span :class="['name-over-style',!data.children || (data.children && data.children.length == 0) ? 'less-width' : '']">{{ data.name }}</span>
              <img v-if="!isOnlyShow && treetype != 3 && !data.finish" style="margin-left:0px;width:14px;height:14px" src="@/assets/img/index-stat/igw-f-warning.svg" />
            </span>
            <template v-if="!isOnlyShow">
              <span class="showSetting inline-block" v-if="treetype == '1'">
                <el-popover
                  placement="right-start"
                  trigger="hover"
                  popper-class="operation-pop"
                  v-model="data.showPopOver"
                  :modal-append-to-body="false"
                >
                  <div class="wordStyle renameStyle" @click="editNodeName(data)">编辑</div>
                  <div class="wordStyle renameStyle" @click="openConfirmDel(data)">删除</div>
                  <div slot="reference" style="padding-right:2px">        
                    <i class="iconfont text-theme-black-850 icon-jc-setting text-xs"></i>
                  </div>
                </el-popover>
              </span>
            </template>
          </span>
        </el-tree>
      </template>
    </div>
    <!-- 地区说明弹框 -->
    <el-dialog
    title=" 添加地区说明及教程"
    :visible.sync="areaDescVisible"
    width="30%"
    center
    @close="areaDescVisible=false">
    </el-dialog>
    <!-- 编辑弹窗 -->
    <rename-dialog :renameDialog.sync="renameDialog" :dialogParams="dialogParams" />
    <!-- tip提示弹框 -->
    <setting-tip-dialog :tipDialog.sync="tipDialog" :tipName="tipName" />
    <!-- 确认删除弹框 -->
    <el-dialog
      :title="delTitle"
      :visible.sync="delDialogVisible"
      width="30%"
      @close="delDialogVisible=false">
      <p v-if="treetype == 1">删除指标后，所有相关配置将一并删除，不可恢复</p>
      <p v-else>删除后不可恢复</p>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="delDialogVisible = false">取 消</el-button> -->
        <el-button type="danger" @click="sureDelete">删除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RenameDialog from './RenameDialog.vue';
import SettingTipDialog from './SettingTipDialog';
import { indicatorDimensionDel } from '@/api/index-statistics'
import { mapGetters } from 'vuex'
export default {
  name: 'LeftTree',
  components: {RenameDialog, SettingTipDialog},
  props: {
    treetype: String, //维度类型 1 指标 2 地区 3 时间
    isShowLast: { //是否展示末级指标
      type: Boolean,
      default: true
    },
    isOnlyShow: { 
      type: Boolean,
      default: false
    },
    treeData: Array,
    defaultExpandedKeys: {
      type: Array,
      default: () => {}
    },
    currentNodeKey: {
      type: String | Number,
      default: ''
    },
    showDimensionHead: {
      type: Boolean,
      default: true
    },
    wrapTreeNum: {
      type: Number,
      default: 3
    }
  },
  watch: {
    isShowLast(v){
      this.$nextTick(() => {
          if(this.$refs.tree) this.$refs.tree.filter();
      })
    },
    treeData: {
      handler(v) {
        this.treeDataArr = v
        this.$nextTick(() => {
          if(this.$refs.tree) this.$refs.tree.filter();
          this.$refs.tree?.setCurrentKey(this.showCurNode)
        })
        this.$forceUpdate()
      },
      deep: true
    },
    currentNodeKey(v) {
      this.$nextTick(() => {
        this.showCurNode = v
        this.$refs.tree.setCurrentKey(v)
        this.$forceUpdate()
      })
    },
    isOnlyShow(v){
      if(!v) this.addOuterWarp()
    },
    defaultExpandedKeys(v) {
      if(v) this.showExpanedKeys = v
    },
    showCurNode(v) {
    }
  },
  data() {
    return {
      treeDataArr: [],
      settingName: {1:'指标',2:'地区',3:'时间'},
      areaDescVisible: false, // 地区说明弹框
      renameDialog: false,
      dialogParams: {
        title: '重命名',
        id: 1,
        name: '重命名',
        data: {},
        treetype: 1
      },
      delDialogVisible: false,
      curNodeData: {},
      tipDialog: false,
      tipName: 'index',
      defaultProps: {
        children: 'children',
        label: 'id',
        isLeaf: (data, node) => {
          return true
        }
      },
      showExpanedKeys: [],
      showCurNode: ''
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
    wrapTreeClass() {
      switch (this.wrapTreeNum) {
        case 1: 
          return 'wrap-tree-1';
        case 2:
          return 'wrap-tree-2';
        case 3:
          return ''
      }
    },
    delTitle(){
      return '确定删除'+ (this.treetype == 1 ? '指标' : '该地区/地区分组')+'？'
    }
  },
  created() {
    this.treeDataArr = this.treeData
    if(this.isOnlyShow) this.addOuterWarp()
    this.$forceUpdate()
  },
  mounted() {
    if(this.defaultExpandedKeys) this.showExpanedKeys = this.defaultExpandedKeys
    this.showCurNode = this.currentNodeKey
    this.$nextTick(() => {
      this.$refs.tree?.setCurrentKey(this.showCurNode)
      this.$forceUpdate()
    })
    if(this.$refs.tree) this.$refs.tree.filter();
    let _ = this
    this.$surveyBus.$on('changeCurrentNode',function(data){
      _.$nextTick(() => {
        _.$refs.tree?.setCurrentKey(data)
        _.$forceUpdate()
      })
    })
  },
  methods: {
    openNode (data, node, self) {
      // 保存当前展开的节点
      let flag = false
      this.showExpanedKeys?.some(item => {
        if (item === data.id) { // 判断当前节点是否存在， 存在不做处理
          flag = true
          return
        }
      })
      if (!flag) { // 不存在则存到数组里
        this.showExpanedKeys?.push(data.id)
      }
    },
    closeNode (data, node, self) {
      // 删除当前关闭的节点
      this.showExpanedKeys?.some((item, i) => {
        if (item === data.id) {
          this.showExpanedKeys.splice(i, 1)
        }
      })
      // 这里主要针对多级树状结构，当关闭父节点时，递归删除父节点下的所有子节点
      this.removeChildrenIds(data)
    },
     // 删除树子节点
    removeChildrenIds(data) {
      const ts = this
    //懒加载的时候想要删除子节点  得在加载下级数据时添加上data.children
      if (data.children) {
        data.children.forEach(function(item) {
          const index = ts.showExpanedKeys.indexOf(item.id)
          if (index != -1) {
            ts.showExpanedKeys.splice(index, 1)
          }
          ts.removeChildrenIds(item)
        })
      }
    },
    clickTreeNode(node, data) {
      this.showCurNode = data.id
      this.$nextTick(() => {
        this.$refs.tree?.setCurrentKey(this.showCurNode)
        this.$forceUpdate()
      })
      this.$emit('clickTreeNode',data)
    },
    clickOneLevelIcon(node,data) {
      this.$emit('clickOneLevelIcon',data)
    },
    filterTreeNode(value, data, node){
      // 只存在一级指标时 不隐藏
      if(data.fatherId == 0 && (!data.children || data.children.length == 0)){
        return true
      }
      return this.isShowLast || (data.children && data.children.length > 0)
    },
    openAreaDescDialog(){
      this.areaDescVisible = true
    },
    editNodeName(data){
      // 地区分类编辑 自定义方法
      if(this.treetype == 2) {
        this.$emit('editAreaClass',data)
        return
      }
      this.renameDialog = true
      this.dialogParams = {
        title: '编辑指标名称',
        id: data.id,
        name: data.name,
        data: data,
        treetype: this.treetype
      }
    },
    openConfirmDel(data){
      this.delDialogVisible = true
      this.curNodeData = data
    },
    sureDelete() {
      this.delDialogVisible = false
      if(this.treetype == 1) {
        // 指标维度树删除
        indicatorDimensionDel(this.curNodeData).then(res => {
          if(res.data.code == 0 && res.data.data) {
            this.$parent.getIndexDimensionList()
            this.$parent.tableType = 0
            this.$parent.updataCellTable()
            this.$refs.tree?.setCurrentKey(this.showCurNode)
            this.$forceUpdate()
          }else{
            this.$message.error(res.data.msg || '删除失败!')
          }
        })
      }
    },
    openTipDialog() {
      const tipObj = {1 : 'index' ,2 : 'area', 3 : 'time'}
      this.tipName = tipObj[this.treetype]
      this.tipDialog = true
    },
    clickDimensionTiltle() {
      this.$emit('clickDimensionTiltle')
    },
    // 图表查看添加外层指标 地区
    addOuterWarp(){
      const data = JSON.stringify(this.treeDataArr)
      let dataJson = JSON.parse(data)
      if(this.treetype == 1){
        let obj = [{
          name: '指标',
          id: '指标',
          children: dataJson
        }]
        this.treeDataArr = obj
      }else if(this.treetype == 2){
        let obj = [{
          name: '地区',
          id: '地区',
          children: dataJson
        }]
        this.treeDataArr = obj
      }
    },
  }
}
</script>
<style lang="scss">
.custom-icon-tree{
  color: #000;
  padding: 0px !important;
  font-size: 14px;
}
.rotate90{
  transform: rotate(90deg);
}
.hover-blue-icon:hover{
  @apply text-theme;
}
.wrap-tree .el-tree-node__content{
  height: 32px !important;
}
.el-tree-node__expand-icon.expanded{
  /* transform: rotate(-90deg) !important; */
}

 
::v-deep .is-leaf::before {
  // 隐藏或加透明都可以
  // display: none;
  // opacity: 0 !important;
}
::v-deep .el-tree-node__content>.el-tree-node__expand-icon {
  position: absolute;
  opacity: 0;
}

::v-deep .el-tree-node__content {
  position: relative;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
  background: #fff;
  @apply text-theme;
}
.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content .name-over-style{
  @apply text-theme;
}
.el-tree-node__content:hover {   
  background-color: #fff;
}
.custom-tree-node:hover{
  background-color: #f5f5f5;
  color: rgba($color: #000000, $alpha: 0.85) !important;
}
.custom-tree-node:hover .name-over-style{
  color: rgba($color: #000000, $alpha: 0.85) !important;
}
</style>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 15px 20px 10px;
}
.custom-tree-node {
  font-size: 14px;
  height: 32px;
  overflow: auto;
  .name-over-style{
    max-width: 122px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .less-width{
    max-width: 110px;
  }
}
.custom-tree-node:hover {
  @apply text-theme;
}
.wrap-tree{
  width: 198px;
  height: calc((100vh - 110px) / 3);
  overflow: auto;
  border-bottom: 1px solid #E7E9EB;
}
.wrap-tree-1{
  height: calc((100vh - 110px) / 1);
  border-bottom: none;
}
.wrap-tree-2{
  // height: calc((100vh - 110px) / 2);
  height: auto;
  border-bottom: none;
}
.showSetting{
 display: none;
}
.custom-tree-node:hover .showSetting{
  display: block;
}
.peizhi-title{
  font-family: PingFangSC-Medium;
  font-weight: 500;
  line-height: 32px;
  font-size: 14px;
}
.no-data-tree{
  font-size: 14px;
  img{
    margin-left: 2px;
  }
  .add-word{
    @apply text-theme;
    height: calc(((100vh - 110px) / 3) - 40px);
  }
}
</style>
